import { IReportDataService, IReportDataConversionService, ReportDataServiceHelper} from "Services";
import { IOptimization, IReportOptimization,  IMeasurementReport, IDispersionEllipse, ICoordinate2D} from "Data";
import  * as Q from "q";

declare var reportAsync: any;

export class TpsReportDataService implements IReportDataService {

    private dataConversionService: IReportDataConversionService;
  
    public static $inject = ['IReportDataConversionService'];
    private static reportData: IMeasurementReport;

    constructor(dataConversionService: IReportDataConversionService) {
        this.dataConversionService = dataConversionService;
    }

    getReportData(reportId: string): Q.Promise<[IMeasurementReport, boolean]> { 
        return Q.all([
            this.loadReport(),
            this.deviceOnline()
        ]);
    }

    getOptimizationData(measurementId: Array<string>, optimizationType: string, reportId: string): Q.Promise<IReportOptimization> {
        var defered = Q.defer<IReportOptimization>();
        reportAsync.getOptimizedData(measurementId, optimizationType)
            .then((response: string) => {
                    if (response) {
                        var data: IOptimization = JSON.parse(response);
                        defered.resolve(this.dataConversionService.convertOptimizedData(data));
                    }
                },
                (reason: any) => {
                    console.log(reason);
                    defered.reject(null);
                });
        return defered.promise;
    }

    private dispersionCacheRequest: Map<string, ICoordinate2D[]> = new Map<string, ICoordinate2D[]>();
    private dispersionCacheResponse: Map<string, IDispersionEllipse> = new Map<string, IDispersionEllipse>();

    getDispersionEllipse(coordinates: Array<ICoordinate2D>, colorOfElllipsis: string): Q.Promise<IDispersionEllipse> {
        var defered = Q.defer<IDispersionEllipse>();

        if (this.dispersionCacheResponse.get(colorOfElllipsis)) {
            if (ReportDataServiceHelper.compareDispersionCoordinates(this.dispersionCacheRequest.get(colorOfElllipsis) ?? [], coordinates)) {
                defered.resolve(this.dispersionCacheResponse.get(colorOfElllipsis));
                return defered.promise;
            }
        }
        var self = this;
        reportAsync.getDispersionEllipse(coordinates)
            .then((response: string) => {
                var ellispe: IDispersionEllipse = JSON.parse(response);

                    self.dispersionCacheRequest.set(colorOfElllipsis, coordinates);
                    self.dispersionCacheResponse.set(colorOfElllipsis,ellispe);
                    defered.resolve(ellispe);
                },
                (reason: any) => {
                    console.log(reason);
                    defered.reject(null);
                }
            );
        return defered.promise;
    }


    private loadReport(): Q.Promise<IMeasurementReport> {
        var defered = Q.defer<IMeasurementReport>();
        const reportId = "";
        if (TpsReportDataService.reportData) {
            defered.resolve(TpsReportDataService.reportData);
        }
        reportAsync.getMultiGroupReport(reportId)
            .then((response: string) => {
                    if (response) {
                        var report = JSON.parse(response);
                        TpsReportDataService.reportData = this.dataConversionService.convertData(report);
                        
                        defered.resolve(TpsReportDataService.reportData);
                    }
                },
                (reason: any) => {
                    console.log(reason);
                    defered.reject(null);
                });
        return defered.promise;
    }
   
    private deviceOnline(): Q.Promise<boolean> {
        var defered = Q.defer<boolean>();        
        defered.resolve(true);
        return defered.promise;
    }

    shortenUrl(url: string): Q.Promise<string> {
         throw new Error("Not implemented");
    }
}